(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ce-care"] && !Shopify.designMode) return;
  try {
    
(function() {
  var nav = document.getElementById('careNav');
  if (!nav) return;

  var links = Array.prototype.slice.call(nav.querySelectorAll('a[data-topic]'));
  var sections = links
    .map(function(link) { return document.getElementById(link.getAttribute('data-topic')); })
    .filter(Boolean);
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function centerPill(pill) {
    if (nav.scrollWidth <= nav.clientWidth) return;
    var target = pill.offsetLeft - (nav.clientWidth - pill.offsetWidth) / 2;
    nav.scrollTo({ left: target, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  }

  function setActive(id) {
    links.forEach(function(link) {
      var isActive = link.getAttribute('data-topic') === id;
      link.classList.toggle('active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'true');
        centerPill(link);
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  links.forEach(function(link) {
    link.addEventListener('click', function(event) {
      var id = link.getAttribute('data-topic');
      var section = document.getElementById(id);
      if (!section) return;
      event.preventDefault();
      history.replaceState(null, '', '#' + id);
      section.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      setActive(id);
    });
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) setActive(entry.target.id);
      });
    }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
    sections.forEach(function(section) { observer.observe(section); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ce-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const el = document.getElementById('ce-loc-time');
    if (!el) return;

    const render = () => {
      const time = new Date().toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'America/Phoenix'
      });
      el.textContent = `${time} MST`;
    };

    render();
    setInterval(render, 30000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ce-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  var rotator = document.querySelector('.ce-hero-rotator');
  if (!rotator) return;
  var slides = rotator.querySelectorAll('.ce-hero-slide');
  if (slides.length < 2) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var index = 0;
  var paused = false;
  rotator.addEventListener('mouseenter', function () { paused = true; });
  rotator.addEventListener('mouseleave', function () { paused = false; });
  rotator.addEventListener('focusin', function () { paused = true; });
  rotator.addEventListener('focusout', function () { paused = false; });

  setInterval(function () {
    if (paused || document.hidden) return;
    slides[index].classList.remove('is-active');
    slides[index].setAttribute('aria-hidden', 'true');
    slides[index].setAttribute('tabindex', '-1');
    index = (index + 1) % slides.length;
    slides[index].classList.add('is-active');
    slides[index].removeAttribute('aria-hidden');
    slides[index].removeAttribute('tabindex');
  }, parseInt(rotator.dataset.interval || '5000', 10));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  var bars = document.querySelectorAll('.ce-sticky-atc');
  if (!bars.length || !('IntersectionObserver' in window)) return;
  bars.forEach(function (bar) {
    var target = document.getElementById(bar.dataset.observe);
    if (!target) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.hidden = entry.isIntersecting;
      });
    }, { threshold: 0 });
    observer.observe(target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
